module.exports = __webpack_public_path__ + "src/assets/individualImages/mainMenuTitle.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/mainMenuTitle.png
// module id = ./src/assets/individualImages/mainMenuTitle.png
// module chunks = 0